<div class="backIcon">
    <mat-icon class="close-icon" [routerLink]="['/private-space/view-sporsorship-requests']">close</mat-icon>
    <mat-icon class="create-icon" (click)="onEditSponsorship()" >create</mat-icon>
  </div>
  <div class="text-center mat-header">
    View Sponsorship Request
  </div>
  <div class="form-group col-sm-12 text-center" *ngIf="isLoading">
    <img class="loader" src="../../assets/images/loader.gif" width="60px" alt="">
  </div>
  <mat-card-content *ngIf="!isLoading">
    <form [formGroup]="editSponsorshipForm" (ngSubmit)="onSubmitEditForm()"
    class="row g-3 needs-validation">
    <div class="form-group col-sm-12">
      <label  for="sponsorshipName">Sponsorship Name</label>
      <input readOnly class="form-control" aria-describedby="basic-addon1" aria-label="SponsorshipName" id="sponsorshipName"
        formControlName="name" type="text" readOnly />
    </div>

    <div class="form-group col-sm-12">
        <label  for="searchProperty">Property</label>

        <input readOnly class="form-control"   id="searchProperty" placeholder="Search Property" formControlName="propertyName" type="text" value="" />
        <span
        class="validation-error"
        *ngIf="
          (customStylesValidated || editSponsorshipForm.controls.propertyName.touched) &&
          editSponsorshipForm.controls.propertyName.errors?.required
        "
        >Please fill</span
      >

      </div>
    
      <div class="form-group col-sm-12">
        <label  for="searchSponsor">Sponsor</label>
        <input readOnly class="form-control" type="text"  formControlName="sponsorName"
        placeholder="Search Sponsor" >
        <span
        class="validation-error"
        *ngIf="
          (customStylesValidated || editSponsorshipForm.controls.sponsorName.touched) &&
          editSponsorshipForm.controls.sponsorName.errors?.required
        "
        >Please fill</span
      >
      </div>

    <div class="form-group col-sm-6">
      <label  for="sponsorshipValue">Value</label>
      <input readOnly class="form-control" id="sponsorshipValue" formControlName="value" required type="text" readOnly />
    </div>
    <div class="form-group col-sm-6">
      <label  for="sponsorshipType">Sponsorship Type</label>
      <input readOnly class="form-control" id="sponsorshipType" formControlName="type" required type="text" readOnly />
    </div>

    <div class="form-group col-sm-6">
      <label  for="sponsorshipStatus">Status</label>
      <!-- <select readOnly aria-readonly="true" class="form-control" id="sponsorshipStatus" formControlName="status" readOnly>
        <option value="">Choose...</option>
        <option>NEW</option>
        <option>ACTIVE</option>
        <option>REJECTED</option>
        <option>CLOSED</option>
      </select> -->
      <input class="form-control" id="status" formControlName="status" type="text" readonly />
    </div>

  </form>
  <!-- <div class="text-center mat-header mt-2">
    Linked Sponsorships
  </div>
  <table  *ngIf="!isLoading"
  class="mb-0 border table table-striped table-hover table-bordered">
  <thead>
    <tr>
      <th><small>Name</small></th>
      <th class=""><small>Property Name</small></th>
      <th class=""><small>Sponsor Name</small></th>
      <th class=""><small>Value</small></th>
      <th class=""><small>Status</small></th>
    </tr>
  </thead>
  <tbody>
    <tr class="pointer" *ngFor="let sponsorship of sponsorships; index as i" (click)="OpenSponsorship(sponsorship)">
      <td>
        <div>{{ sponsorship.name }}</div>
      </td>
      <td class="text-center">
        <div>{{ sponsorship.propertyName }}</div>
      </td>
      <td class="text-center">
        <div>{{ sponsorship.sponsorName }}</div>
      </td>
      <td class="text-center">
        <div>{{ sponsorship.value }}</div>
      </td>
      <td class="text-center">
        <div>{{ sponsorship.status }}</div>
      </td>
    </tr>
  </tbody>
</table> -->
  </mat-card-content>